<template>
  <div>
    <template v-if="data != null && dataChosen != null">
      <v-row>
        <v-col cols="12" align="center">
          <v-btn :elevation="6" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark :color="'primary'"> {{ $t("escb.pieCharts.buttonCurrent") }} </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="6" md="4" lg="3" align="center">
          <v-row no-gutters>
            <v-col cols="12">
              <h3 class="text-center">{{ $t("escb.pieCharts.currentPower") }}</h3>
            </v-col>

            <v-col cols="12">
              <ApexGradientDonutChart2
                :data="data.current"
                :colors="['#9C27B0', '#2196F3']"
                :units="'kW'"
                :label="[
                  $t('escb.pieCharts.loadY1'), //
                  $t('escb.pieCharts.loadY2'), //
                ]"
                :header="'AAA'"
                :width="600"
                :dark="$vuetify.theme.dark"
              >
              </ApexGradientDonutChart2
            ></v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" align="center">
          <v-btn :elevation="displayInfo === 1 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(1)" :color="displayInfo === 1 ? 'primary' : 'grey'">
            {{ $t("escb.pieCharts.buttonToday") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 2 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(2)" :color="displayInfo === 2 ? 'primary' : 'grey'">
            {{ $t("escb.pieCharts.buttonYesterday") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 3 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(3)" :color="displayInfo === 3 ? 'primary' : 'grey'">
            {{ $t("escb.pieCharts.buttonWeek") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 4 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(4)" :color="displayInfo === 4 ? 'primary' : 'grey'">
            {{ $t("escb.pieCharts.buttonMonth") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 5 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(5)" :color="displayInfo === 5 ? 'primary' : 'grey'">
            {{ $t("escb.pieCharts.buttonYear") }}</v-btn
          >
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="6" md="4" lg="3" align="center">
          <v-row no-gutters>
            <v-col cols="12">
              <h3 class="text-center">
                <template v-if="displayInfo === 1"> {{ $t("escb.pieCharts.loadToday") }} </template>
                <template v-else-if="displayInfo === 2"> {{ $t("escb.pieCharts.loadYesterday") }} </template>
                <template v-else-if="displayInfo === 3"> {{ $t("escb.pieCharts.loadWeek") }} </template>
                <template v-else-if="displayInfo === 4"> {{ $t("escb.pieCharts.loadMonth") }} </template>
                <template v-else-if="displayInfo === 5"> {{ $t("escb.pieCharts.loadYear") }} </template>
              </h3>
            </v-col>

            <v-col cols="12">
              <ApexGradientDonutChart2
                :data="dataChosen"
                :colors="['#9C27B0', '#2196F3']"
                :units="'kWh'"
                :label="[
                  $t('escb.pieCharts.loadY1'), //
                  $t('escb.pieCharts.loadY2'), //
                ]"
                :header="'AAA'"
                :width="600"
                :dark="$vuetify.theme.dark"
              >
              </ApexGradientDonutChart2
            ></v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--       <v-row>
        <v-col cols="12">

          Pokud budeme chtít se šoupat v čase tak parametry dt1 a dt2

          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn x-large icon dark color="primary" v-on="on">
                <v-icon>mdi-calendar-today</v-icon>
              </v-btn>
            </template>

            <v-date-picker @change="onChangeDatePickerEvent()" v-model="picker" :locale="`${$i18n.locale}`"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row> -->

      <!--       <v-col cols="12" align="center">
        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn x-large icon dark color="primary" v-on="on">
              <v-icon>mdi-calendar-today</v-icon>
            </v-btn>
          </template>

          <v-date-picker @change="onChangeDatePickerEvent()" v-model="picker" :locale="`${$i18n.locale}`"></v-date-picker>
        </v-menu>
      </v-col> -->

      <!--       <v-row>
        <v-col cols="12">
          <i>
            INFO: <br />
            [import dist, import dodavatel] DEBUG: <br />
            Current: {{ data.current }} <br />
            Today: {{ data.loadToday }}<br />
            Yesterday: {{ data.loadYesterday }}<br />
            Week: {{ data.loadWeek }}<br />
            Month: {{ data.loadMonth }}<br />
            Year: {{ data.loadYear }}<br />
            PARAMETERS: {{ debugParameter }} <br />
            PICKER: {{ picker }} <br /><br />
            DATA: {{ data }}
          </i>
        </v-col>
      </v-row> -->
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { ServiceClient } from "../../service_client/index.js";

import ApexGradientDonutChart2 from "../../components/charts/apexcharts/ApexGradientDonutChart2.vue";

import LoadingData from "../../components/LoadingData.vue";

import * as MyColors from "../../colors.js";

export default {
  name: "ESCBPieCharts",
  props: {},
  components: {
    ApexGradientDonutChart2,
    LoadingData,
  },
  data() {
    return {
      colors: MyColors,

      data: null,
      dataChosen: null,

      debugParameter: "",

      displayInfo: 1,

      picker: new Date().toISOString().substring(0, 10),

      timer: null,
      mobile: false,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.getData();

    setTimeout(() => {
      this.switchDonutChart();
    }, 250);
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    switchDonutChart() {
      switch (this.displayInfo) {
        case 1:
          this.dataChosen = this.data.loadToday;
          break;

        case 2:
          this.dataChosen = this.data.loadYesterday;
          break;

        case 3:
          this.dataChosen = this.data.loadWeek;
          break;

        case 4:
          this.dataChosen = this.data.loadMonth;
          break;

        case 5:
          this.dataChosen = this.data.loadYear;
          break;

        default:
          break;
      }
    },
    changeDisplayInfo(number) {
      this.displayInfo = number;
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        // Dle vybraného grafu měnit rychlost vyčítání a při změne!
        this.getData();
        this.switchDonutChart();
      }, 5000);
    },
    getData() {
      /*
      "?time=d&type=E&limit=365"

       time=d
       &
       type=E
       &
       limit=7
       &
       dt1=
       &
       dt2=
       */

      /*
      chartInterval: ["M", "H", "d", "d", "m", "M", "S"],
      limit: ["60", "24", "7", "31", "12", "360", "60"],
      */

      let time = "";
      let limit = "";
      let type = "";

      switch (this.displayInfo) {
        case 0:
          time = "M";
          type = "P";
          limit = "1";
          break;
        case 1:
          time = "d";
          type = "E";
          limit = "1";
          break;
        case 2:
          time = "d";
          type = "E";
          limit = "7";
          break;
        case 3:
          time = "m";
          type = "E";
          limit = "1";
          break;
        case 4:
          time = "m";
          type = "E";
          limit = "12";
          break;

        default:
          break;
      }

      // TODO PARAMETERS?
      let parameters = "?" + "time" + "=" + time + "&" + "type" + "=" + type + "&" + "limit" + "=" + limit;

      this.debugParameter = parameters;

      /*
      ServiceClient.dataCore(ServiceClient.getAPIUrl("escbchartpies"), null, parameters, "GET")
      */

      // Zatím bez dotazu...
      ServiceClient.dataCore(ServiceClient.getAPIUrl("escbchartpies"), null, null, "GET")
        .then((data) => {
          // HOP mi odpoví takhle: {load: []}
          this.data = data;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
  watch: {
    displayInfo: function () {
      /* this.getData(); */

      this.switchDonutChart();
    },
  },
};
</script>

<style scoped></style>
